import { createContext } from "react";
/**
 * Context for injecting a different set of components for rendering options
 *
 * - Default (radio, select, ...)
 * - Card components (thumbnail)
 */
export const ValueComponentContext = createContext({});
ValueComponentContext.displayName = "ValueComponentContext";
/**
 * For overriding the parent value components
 */
export const ParentValueComponentContext = createContext({});
ParentValueComponentContext.displayName = "ParentValueComponentContext";
//# sourceMappingURL=ValueComponentContext.js.map